import { Milliseconds } from '@iotv/iotv-v3-types'

/** Period Units to be used in TimeBucketDefinitions,
 * for convenience these have values in Milliseconds, but be warned these are approximate for YEAR and MONTH
 * Usage in bucketing functions based on getTimeBucketStartDateTimeForTimestamp aims to take into account correct variation in YEAR and MONTH
 */
export enum TimeBucketUnits {
  YEAR = Milliseconds.DAY.valueOf() * 365,
  MONTH = Milliseconds.DAY.valueOf() * 31,
  DAY = Milliseconds.DAY.valueOf(),
  HOUR = Milliseconds.HOUR.valueOf(),
  QUARTERHOUR = Milliseconds.MINUTE.valueOf() * 15,
  MINUTE = Milliseconds.MINUTE.valueOf(),
}

export type TimeBucketType = {
  width: number
  unit: TimeBucketUnits
  offset?: number
  UTCOffset?: number
}

export type TimeBucketRequest = { timeBucketDef: TimeBucketType; startTimestamp: number; endTimestamp: number }

export type TimeBucket = [startTimestamp: number, endTimestamp: number]

export type GetTimeBucketForTimestampInput = { timeBucketDef: TimeBucketType; timestamp: number }
